import Vue from 'vue'
import Router from 'vue-router'

import settingRouter from './module/setting.js'
import orderRouter from './module/order.js'
import dataCenterRouter from './module/dataCenter.js'
import seedlingRouter from './module/seedling.js'
import homeRouter from './module/home.js'

// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//     return routerPush.call(this, location).catch(error => error)
// }
Vue.use(Router)

const router = new Router({
    mode: 'history',
    // 路由跳转时让页面滚动到顶部
    scrollBehavior: () => ({
        y: 0
    }),
    routes: [
        {
            path: '/',
            redirect: {
                name: 'index'
            }
        },
        {
            path: '/index.html',
            name: 'index.html',
            meta: {
                requireAuth: false,
                title: '官网',
                level: 0
            },
            component: resolve => require(['../views/index.vue'], resolve)
        },
        {
            path: '/index',
            name: 'index',
            component: resolve => require(['../views/index.vue'], resolve),
            meta: {
                requireAuth: false,
                title: '官网',
                level: 0
            }
        },
        {
            path: '/newsDetails',
            name: 'newsDetails',
            component: resolve => require(['../views/infomation/index.vue'], resolve),
            meta: {
                requireAuth: false,
                title: '苗讯',
                level: 0
            }
        },
        {
            path: '/manager',
            name: 'manager',
            component: resolve => require(['../views/manager.vue'], resolve),
            meta: {
                requireAuth: true,
                title: '企业后台',
                level: 0
            },
            children: [
                // {
                //     path:'/',
                //     redirect: to=>{
                //         return '/manager/seedling/stock';
                //     }
                // },
                orderRouter,
                seedlingRouter,
                settingRouter,
                dataCenterRouter
            ]
        },
        {
            //登录页面
            path: '/login',
            name: 'login',
            meta: {
                requireAuth: false,
                keepAlive: false,
                level: 0,
                title:'登录'
            },
            component: resolve => require(['../views/login/login.vue'], resolve)
        },
        {
            //微信登录回调页面
            path: '/wxLogin',
            name: 'wxLogin',
            meta: {
                requireAuth: false,
                keepAlive: false,
                level: 0,
                title:'微信登录'
            },
            component: resolve => require(['../views/login/wxLogin.vue'], resolve)
        },
        {
            //error 404页面
            path: '*',
            name: 'error',
            meta: {
                level: 0,
                title:'错误'
            },
            component: resolve => require(['../views/error/error.vue'], resolve)
        }
    ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js